import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol',
})
export class CurrencySymbolPipe implements PipeTransform {
  /**
   *
   * @param value currencyCode ad a number
   * @param args
   * @returns currency Symbole as a string
   */
  transform(value: number | undefined, ..._args: unknown[]): string {
    switch (value) {
      case 1: {
        return '€';
      }

      case 2: {
        return '$';
      }

      case 3: {
        return '£';
      }
    }
    return '';
  }
}
